import { companyIdFromInput } from "../domain/company";
import { useCompany } from "../lib/company";

/**
 * Dev-only company switcher. Stands in for Clerk's active-organization picker
 * until Clerk is wired up.
 */
export function CompanySwitcher() {
  const { companies, companyId, setCompanyId } = useCompany();
  if (companies.length === 0) return null;
  return (
    <select
      aria-label="Acting as company"
      className="max-w-[8rem] rounded-lg border border-slate-200 bg-white px-2.5 py-1.5 text-[13px] text-slate-700 hover:border-slate-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--accent)] sm:max-w-[12rem]"
      value={companyId ?? ""}
      onChange={(e) => {
        const selectedCompanyId = companyIdFromInput(companies, e.target.value, companyId);
        if (selectedCompanyId !== null) setCompanyId(selectedCompanyId);
      }}
      title="Acting as company (dev — replaced by Clerk org switcher)"
    >
      {companies.map((c) => (
        <option key={c._id} value={c._id}>
          {c.name}
        </option>
      ))}
    </select>
  );
}
